module.exports = __webpack_public_path__ + "img/04_sub_no.043d7aa6.svg";